import React from 'react';
import ProductCardBaseNew from './ProductCardBaseNew';

const MoveInCard = ({ product, ...otherProps }) => {
  const badge = () => {
    if (product?.duration_in_months === 36) {
      return {
        color: '#2F80EDE5',
        label: 'MIGLIORE',
      };
    }
    if (product?.duration_in_months === 24) {
      return {
        color: '#EB5757',
        label: 'PIÙ VENDUTO',
        fontSize: '0.7rem',
      };
    }
    return undefined;
  };
  return (
    <ProductCardBaseNew
      logo={'move_in_logo'}
      product={product}
      showPrice
      showBigPrice
      {...otherProps}
      description={
        product?.duration_in_months
          ? `Abbonamento ${product?.duration_in_months} mesi`
          : product?.description
      }
      badge={badge()}
    />
  );
};

export default MoveInCard;
